module.exports = new __parcel__URL__("profilepicture.9aa87836.jpeg").toString();